// const printErr = console.error
// console.error = txt => {
// 	console.log("GOT YOU")
// 	printErr(txt)
// }
window.onerror = function(message, source, lineno, colno, error) {
	console.log(message)
	console.log(error)
	if(window.location.host.indexOf('localhost') > -1) {
		return
	}
	fetch(`${global.SERVER_URL}/reportError`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			errMsg:`Client Error!
			${window.location.href}
			${global._curPos}
			${source}
			${lineno}
			${colno}
			Error: ${error}
			Message: ${message}
			Navigator.userAgent: ${navigator.userAgent}`
		})
	})
	// console.log('send', 'event', 'window.onerror', message, navigator.userAgent);
}
function sendData(surveyKey, uId, cb) {
	global.addLoader && global.addLoader()
	console.log(JSON.stringify(global.ansData,null,2))
	if(uId[0] === '?') {
		uId = 'NONE'
	}
	
	// Close record in cache server
	if (global.rid && global.ansData && global.ansData.seedNumber && surveyKey) {
		console.log('hc send')
		fetch(`${global.CACHE_URL}/finishAns`, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				uid: global.rid, 
				sekerKey: surveyKey, 
				data: global.ansData,
				params: {},	
			})
		})
	} else {
		console.log({global})
	}

	// Submit to regular server
	fetch(`${global.SERVER_URL}/submitUserSurvey/${surveyKey}/${uId}`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(global.ansData)
	}).then(respond => {
		// console.log("respond:")
		// console.log(respond)
		if(uId.indexOf('ipnl_q_') === 0) {
			// without quata
			// window.location.href = 'https://www.ipanel.co.il/SurveyInterface/RedirectBackToSG.html'
			// with quata
			// window.location.href = 'https://surveys.ipanel.co.il/s3/SXXXXXX?user9=completed/screened/screenedfullquata'
			window.location.href = 'https://surveys.ipanel.co.il/s3/S415785?user9=completed'
		}
		global._appOnSekerEnded && global._appOnSekerEnded(global.ansData)
		setTimeout(() => {
			respond.text().then(txt => {
				try{
					global.SumbitResult = JSON.parse(txt)
				} catch(e) {
					//
				}
				cb(respond.statusText === "OK")
			}).catch(() => {
				cb(respond.statusText === "OK")
			})	
			global.subLoader && global.subLoader()	
			// global.PlayHeadAnimation("hat");
		}, 2000)


	}).catch(err => {
		console.log("Err:")
		console.log(err)
		cb(false)
		global.subLoader && global.subLoader()

	})
}

export default {
	sendData,
}


// WEBPACK FOOTER //
// ./src/SubmitAPI.js